import { useLocale } from '@spotify-internal/i18n-core';

export function useCollator(options: Intl.CollatorOptions = {}) {
  const locale = useLocale();
  return new Intl.Collator(locale, options);
}
